var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.401,
    height: 18.43,
    viewBox: "0 0 11.401 18.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logistics",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M173.449,189.85a.349.349,0,0,0,.248-.1l3.15-3.15a.35.35,0,0,0-.5-.5l-2.9,2.9-1.853-1.853a.35.35,0,0,0-.5.5l2.1,2.1A.349.349,0,0,0,173.449,189.85Z",
    transform: "translate(-168.374 -179.49)",
    fill: "#d0c10f",
    stroke: "#d0c10f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M156,372.35a.35.35,0,0,0,.35.35h6.3a.35.35,0,0,0,0-.7h-6.3A.35.35,0,0,0,156,372.35Z",
    transform: "translate(-153.9 -358.979)",
    fill: "#d0c10f",
    stroke: "#d0c10f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M163,432.35a.35.35,0,0,0-.35-.35h-6.3a.35.35,0,0,0,0,.7h6.3A.35.35,0,0,0,163,432.35Z",
    transform: "translate(-153.9 -416.879)",
    fill: "#d0c10f",
    stroke: "#d0c10f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_374",
    "data-name": "Ellipse 374",
    cx: 0.618,
    cy: 0.618,
    r: 0.618,
    transform: "translate(4.982 16.994)",
    fill: "#d0c10f",
    stroke: "#d0c10f",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M103.175,17.921h3.675a.35.35,0,0,0,.35-.35V3.5a.35.35,0,0,0-.35-.35H105.1v-.7a.35.35,0,0,0-.35-.35h-1.233q.008-.087.008-.175a1.925,1.925,0,0,0-3.85,0q0,.088.008.175H98.45a.35.35,0,0,0-.35.35v.7H96.35A.35.35,0,0,0,96,3.5V17.571a.35.35,0,0,0,.35.35h3.675a.35.35,0,1,0,0-.7H96.7V3.85h1.4v.7a.35.35,0,0,0,.35.35h6.3a.35.35,0,0,0,.35-.35v-.7h1.4V17.221h-3.325a.35.35,0,1,0,0,.7ZM104.4,4.2H98.8V2.8h1.315a.35.35,0,0,0,.33-.467,1.225,1.225,0,1,1,2.311,0,.35.35,0,0,0,.33.467H104.4Z",
    transform: "translate(-96)",
    fill: "#d0c10f",
    stroke: "#d0c10f",
    strokeWidth: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistics);
export default __webpack_public_path__ + "static/media/logistics.5eed71e1af0e4ec13700354c02eeb694.svg";
export { ForwardRef as ReactComponent };